@if (content) {
  <div class="richtext-container">
    <div  class="text-center">
      @if (unicodeChar) {
        <div class="unicode" [innerHTML]="unicodeChar"></div>
      }
      @if (content.title1 || content.title2) {
        <div class="heading p-3">
          @if (content.title1) {
            <div class="first">{{ content.title1 }}</div>
          }
          @if (content.title2) {
            <div class="second">{{ content.title2 }}</div>
          }
        </div>
      }
      @if (content.text) {
        <div class="text" [innerHTML]="content.text | sanitize"></div>
      }
    </div>
  </div>
}
